import { View } from "ui/atoms/view";
import { Pressable, Text } from "react-native";
import { PENDING_SIGNOFFS_TABS } from "../../../constants/tabConstants";
import { router, Slot, usePathname } from "expo-router";

export function PendingSignOffsTemplate() {
  const pathname = usePathname();
  return (
    <View>
      <View className="flex-row border-b border-gray-200 mb-8">
        {PENDING_SIGNOFFS_TABS.map((tab) => {
          const isActive = pathname.endsWith(tab.key);
          return (
            <Pressable
              key={tab.key}
              onPress={() => router.push(tab.path)}
              className={`px-4 py-2 ${
                isActive
                  ? "border-b-2 border-primary-600"
                  : "border-b-2 border-transparent"
              }`}
            >
              <Text
                className={`text-base font-semibold ${
                  isActive ? "text-primary-900" : "text-gray-400"
                }`}
              >
                {tab.label}
              </Text>
            </Pressable>
          );
        })}
      </View>

      <Slot />
    </View>
  );
}
